import { render, staticRenderFns } from "./BranchDetailModal.vue?vue&type=template&id=d5226818"
import script from "./BranchDetailModal.vue?vue&type=script&lang=js"
export * from "./BranchDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BranchDetailModal.vue?vue&type=style&index=0&id=d5226818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports